import { action } from "../../../utils/actions";

export const OPEN_PROJECTS_LIST = action("OPEN_PROJECTS_LIST");
export const GET_PROJECTS = action("GET_PROJECTS");
export const OPEN_PROJECT_CREATION = action("OPEN_PROJECT_CREATION");
export const CREATE_PROJECT = action("CREATE_PROJECT");
export const OPEN_PROJECT_EDITION = action("OPEN_PROJECT_EDITION");
export const EDIT_PROJECT = action("EDIT_PROJECT");
export const EDIT_PROJECT_HEALTH_RISKS = action("EDIT_PROJECT_HEALTH_RISKS");
export const OPEN_PROJECT_OVERVIEW = action("OPEN_PROJECT_OVERVIEW");
export const OPEN_PROJECT_HEALTH_RISKS_OVERVIEW = action(
  "OPEN_PROJECT_HEALTH_RISKS_OVERVIEW",
);
export const CLOSE_PROJECT = action("CLOSE_PROJECT");
export const OPEN_ERROR_MESSAGES = "OPEN_ERROR_MESSAGES";
export const OPEN_PROJECT_HEALTHRISKS_EDITION = action(
  "OPEN_PROJECT_HEALTHRISKS_EDITION",
);
